import "../styles/page-layout.scss";
import React, { useState } from "react";
import { SearchBox } from "./search-box";
import { useSelector } from "react-redux";
import { isMobile, UserRole } from "../utilities/constants";
import { GuiTooltip } from "./global-ui/gui-tooltip";

export default function PageLayout({
  title,
  className,
  children,
  tabs,
  buttonBar,
  onMobileSearch,
  searching,
  creditAlert,
  backButton,
  onBackClick = () => {},
  backButtonLabel = "Back",
}) {
  let [showMobileSearch, setShowMobileSearch] = useState(false);
  let loginUser = useSelector((store) => store.user);
  const loginUserType = loginUser?.userType;

  return (
    <div className={"page-layout " + (className || "")}>
      <div
        className={
          "page-layout-header" +
          (showMobileSearch ? " mobile-search" : "") +
          " display-flex " +
          (tabs ? "flex-column" : "flex-row")
        }
      >
        {/* Back Button */}
        {backButton && (
          <div
            style={{
              borderRadius: 4,
              justifyContent: "flex-start",
              alignItems: "center",
              display: "flex",
              padding: "4px 10px",
              cursor: "pointer",
              background: "none",
              border: "none",
              width: "fit-content",
            }}
            className="page-layout-back-btn"
            onClick={onBackClick}
            aria-label={backButtonLabel}
            tabIndex={0}
          >
            <span
              style={{
                textAlign: "center",
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                color: "var(--icon-primary, #757575)",
                fontSize: 14,
                fontFamily: "Font Awesome 6 Pro",
                fontWeight: 400,
                lineHeight: "14px",
                marginRight: 10,
              }}
            >
              <i className="fa fa-chevron-left" />
            </span>
            {!isMobile() && (
              <span
                style={{
                  color: "var(--text-base-secondary, #6B6B6B)",
                  fontSize: 14,
                  fontFamily: "Red Hat Text",
                  fontWeight: 600,
                  wordWrap: "break-word",
                }}
              >
                {backButtonLabel}
              </span>
            )}
          </div>
        )}
        {/* Title */}
        {!backButton && !isMobile() && <h3>{title}</h3>}

        {/* Top Buttons */}
        {buttonBar && (
          <>
            <div className="page-layout-top-buttons">
              <>
                {/* Hide progress-container for UserRole.Member from the start */}
                {loginUser?.userType &&
                  loginUserType !== UserRole.Member &&
                  !isMobile() &&
                  creditAlert && (
                    <div className="progress-container">
                      <div
                        className={
                          creditAlert?.remainingCredits > 0
                            ? "progress-container-text"
                            : "progress-container-text-negative-credit"
                        }
                      >
                        {creditAlert?.remainingCredits <= 0 && (
                          <>
                            <GuiTooltip
                              tooltip="Overage charges will apply for any new messages."
                              placement="top"
                            >
                              <i className="fa fa-exclamation-circle"></i>
                            </GuiTooltip>{" "}
                          </>
                        )}
                        {creditAlert?.remainingCredits} Texts/Voice Messages
                        Left This{" "}
                        {creditAlert?.billingCycle === "Monthly"
                          ? "Month"
                          : "Year"}
                      </div>
                      <progress
                        value={creditAlert?.remainingCredits}
                        max={creditAlert?.totalCredits}
                        className={
                          creditAlert?.remainingCredits > 0
                            ? "styled-progress-bar"
                            : "styled-progress-bar negative-credits"
                        }
                      ></progress>
                    </div>
                  )}
                {onMobileSearch && (
                  <i
                    className="fal fa-search mobile-only"
                    onClick={() => setShowMobileSearch(true)}
                  />
                )}
                {buttonBar}
              </>
            </div>
          </>
        )}

        {showMobileSearch && (
          <div className="page-layout-mobile-search-bar">
            <SearchBox onSearchChange={onMobileSearch} searching={searching} />
            <span
              className="cancel"
              onClick={() => {
                setShowMobileSearch(false);
                onMobileSearch("");
              }}
            >
              Cancel
            </span>
          </div>
        )}

        {/* Tabs */}
        {tabs && (
          <div className="page-layout-tab-bar">
            <div className="page-layout-tabs">{tabs}</div>
          </div>
        )}
      </div>

      {backButton && (
        <div className="people-dashboard-header">
          <span>{title}</span>
        </div>
      )}

      {/* Content */}
      <div className="page-layout-body">{children}</div>
    </div>
  );
}

// Tabs example
//tabs = {<>
//            <TabItem dataQa="all-tab" tab={Path.People} currentTab={tab} onClick={actions.people.changeTab}>All</TabItem>
//            <TabItem dataQa="managers-tab" tab={Path.PeopleManagers} currentTab={tab} onClick={actions.people.changeTab}>Managers</TabItem>
//            <TabItem dataQa="admin-tab" tab={Path.PeopleAdmin} currentTab={tab} onClick={actions.people.changeTab}>Admin</TabItem>
//        </}
